import React from 'react';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, Surface } from '@infoods/lifebase-ui';

import { ScanMetadata } from '../../../../../../interfaces/scanMetadata';
import { openModal } from '../../../../../../../shared/utils/reactUtils/openModal/openModal';
import {
  CUSTOMER_TYPE,
  CustomerType,
} from '../../../../../../../shared/constants/customer/customerType';
import { CustomerInfo } from '../../NgzInbodyIndicatorsTab.settings';
import { InbodyResultSheetModal } from '../../../../../../containers/CustomerReports/InbodyResultSheetModal/InbodyResultSheetModal';
import { ProgressReportModal } from '../../../../../../containers/CustomerReports/ProgressReportModal/ProgressReportModal';
import classes from './CustomerReportsRow.module.scss';

type CustomerReportsRowProps = {
  customerInfo: CustomerInfo;
  customerType: CustomerType;
  entityId?: number;
  availableScansMetadata: ScanMetadata[];
};

const CustomerReportsRow = ({
  customerInfo,
  customerType,
  entityId,
  availableScansMetadata,
}: CustomerReportsRowProps) => {
  const hasNoScans = availableScansMetadata.length === 0;

  const handleOpenDownloadModal = () => {
    openModal((closeModal) => (
      <InbodyResultSheetModal
        customerType={customerType}
        customerId={customerInfo.id}
        customerName={customerInfo}
        entityId={entityId}
        scansMetadata={availableScansMetadata}
        onClose={closeModal}
      />
    ));
  };

  const handleOpenProgressReportModal = () => {
    openModal((closeModal) => (
      <ProgressReportModal
        customerId={customerInfo.id}
        entityId={entityId}
        scansMetadata={availableScansMetadata}
        onClose={closeModal}
      />
    ));
  };

  return (
    <Surface className={classes.container}>
      <div className={classes.leftSide}>
        <span className={classes.title}>Customer Reports</span>
        <span className={classes.description}>Download then print customer reports</span>
      </div>
      <div className={classes.rightSide}>
        <Button
          variant="outlined"
          size="small"
          endIcon={<FileDownloadOutlinedIcon />}
          disabled={hasNoScans}
          onClick={handleOpenDownloadModal}
        >
          Download InBody Result Sheet
        </Button>
        {customerType === CUSTOMER_TYPE.SCAN_IQ && (
          <Button
            variant="contained"
            size="small"
            endIcon={<FileDownloadOutlinedIcon />}
            disabled={hasNoScans}
            onClick={handleOpenProgressReportModal}
          >
            Download Progress Report
          </Button>
        )}
      </div>
    </Surface>
  );
};

export { CustomerReportsRow };
